var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}.cls-2{fill:#999;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Player"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.5,6.75A60.75,60.75,0,1,1,6.75,67.5,60.82,60.82,0,0,1,67.5,6.75M67.5,0A67.5,67.5,0,1,0,135,67.5,67.5,67.5,0,0,0,67.5,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.5,
    y: 41.5,
    width: 12,
    height: 52,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.5,
    y: 41.5,
    width: 12,
    height: 52,
    rx: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.cdb34379e47042d35200266644a51b5d.svg";
export { ForwardRef as ReactComponent };